/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Best_Quick_Oryx_GulpInputs */

const fr_best_quick_oryx_gulp = /** @type {(inputs: Best_Quick_Oryx_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun contact récent`)
};

/**

* @param {Best_Quick_Oryx_GulpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const best_quick_oryx_gulp = /** @type {((inputs?: Best_Quick_Oryx_GulpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Best_Quick_Oryx_GulpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_best_quick_oryx_gulp(inputs)
});